module.exports = __webpack_public_path__ + "img/4.32151156.png";